import { axiosInstance } from 'src/util/axios.js'

const useAirDropsApi = () => {
  const getAirdrops = async () => {
    try {
      const response = await axiosInstance.post('/blockchain-helpers/getAllBulkTransactions')
      return response.data.data.sort((a: any, b: any) => {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      })
    } catch (err) {
      console.error('Get Air Drops error', err)
    }
  }

  const removeAirDrop = async (id: number) => {
    try {
      return await axiosInstance.post('/blockchain-helpers/deleteBulkTransaction', {
        multipleId: [id],
      })
    } catch (err) {
      console.error('Revoke token error', err)
    }
  }

  return { getAirdrops, removeAirDrop }
}

export default useAirDropsApi
